export const REGISTER_EXECUTOR_REQUEST = 'registerexecutor/REGISTER_EXECUTOR_REQUEST';
export const REGISTER_EXECUTOR_SUCCESS = 'registerexecutor/REGISTER_EXECUTOR_SUCCESS';
export const REGISTER_EXECUTOR_FAILURE = 'registerexecutor/REGISTER_EXECUTOR_FAILURE';

export const GETREGIONS_EXECUTOR_REQUEST='registerexecutor/GETREGIONS_EXECUTOR_REQUEST';
export const GETREGIONS_EXECUTOR_SUCCESS='registerexecutor/GETREGIONS_EXECUTOR_SUCCESS';
export const GETREGIONS_EXECUTOR_FAILURE='registerexecutor/GETREGIONS_EXECUTOR_FAILURE';

